import React, { useContext } from "react";
import { PaymentContext } from "wrapper/PaymentWrapper/context/paymentContext";
import { PaymentDetailsInterface } from "./@types";
import { ShimmerRow } from "components/ShimmerRow/shimmer";
import { PaymentDetailsWrapper } from "./assets/style";
import PriceDetails from "@nykaa/payment-sdk/src/PaymentDetails/mobile";
import { useHistory } from "react-router-dom";

/**
 *
 * @param param0 extraClass is for the  css
 * @description payment Details component is to show the payment(bag details) in checkout, includes discount and shipping charges.
 * getting data from payment wrapper which is the parent wrapper component for payment.
 */

const PaymentDetails = ({ deliverTo, priceDetailConfig }: PaymentDetailsInterface) => {
  const history = useHistory();
  const paymentContext: any = useContext(PaymentContext);
  const ref = priceDetailConfig?.myRef;
  const cartInfo = paymentContext?.cartInfo;
  const paymentDetails = cartInfo?.paymentDetails;

  if (!Object.keys(paymentDetails).length) {
    return (
      <div>
        {[...Array(4)].map((key, value) => (
          <div
            key={`priceDetails-${value}`}
            className="prl15 layout horizontal justified center wrap "
          >
            <ShimmerRow margin="10px" width="100%" height="79px" />
          </div>
        ))}
      </div>
    );
  }

  return (
    <PaymentDetailsWrapper>
      <div ref={ref}>
        <PriceDetails
          {...priceDetailConfig}
          deliverTo={deliverTo}
          innerPadding={true}
          history={history}
        />
      </div>
    </PaymentDetailsWrapper>
  );
};

export default PaymentDetails;
